import { get, find } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getSettingsPos } from '../index';

export const getPosTrackingMethods = createSelector(
  getSettingsPos,
  get('trackingMethods')
);

export const getAll = createSelector(getPosTrackingMethods, get('all'));

export const getTrackingMethodForId = createSelector(
  (_, id) => ({ id }),
  getAll,
  find
);

export const getIsFetching = createSelector(
  getPosTrackingMethods,
  get('fetching')
);
export const getIsFetched = createSelector(
  getPosTrackingMethods,
  get('fetched')
);
export const getFetchingError = createSelector(
  getPosTrackingMethods,
  get('fetchingError')
);
